import { writable } from 'svelte/store';
import type {
	HybridDropConfig,
	SetDiscountConfig,
} from '#lib/features/live-drop-info/types.js';

export type CartIconContext = ReturnType<typeof createCartIconContext>;

// One entry per product id: its drop type, its drop's Hybrid_Config when the
// drop is hybrid, and its drop's set discounts.
export type DropTypes = Record<
	string,
	{
		type: string;
		dropPageSlug?: string;
		hybridConfig?: HybridDropConfig | null;
		setDiscounts?: SetDiscountConfig[];
	}
>;

type createCartIconContextArgs = {
	showCartIcon?: boolean;
};

export const createCartIconContext = (
	initialValues?: createCartIconContextArgs
) => {
	const showCartIcon = writable(!!initialValues?.showCartIcon);
	const dropTypes = writable<null | DropTypes>(null);

	const enableCartIcon = () => {
		showCartIcon.set(true);
	};

	const hideCartIcon = () => {
		showCartIcon.set(false);
	};

	const setDropTypes = (newDropTypes: DropTypes) => {
		dropTypes.set(newDropTypes);
	};

	return {
		showCartIcon,
		dropTypes,
		enableCartIcon,
		hideCartIcon,
		setDropTypes,
	};
};
